import React, { useEffect, useState } from 'react'
// import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import IconTitle from 'components/IconTitle';

import vw from 'styles/utils';
import media from 'styles/media';

import { getPopularArticle } from 'utils/request';
// import hotArticle from 'data/hotArticle';

function Hot(props) {
  // const [featureNews, setFeatureNews] = useState({})
  const [popularArticle, setPopularArticle] = useState('empty')

  useEffect(() => {
    async function fetchData() {
      // const featureNews = await getFeatureNews();
      const popularArticle = await getPopularArticle();

      // setFeatureNews(featureNews)
      await setPopularArticle(popularArticle)
      // await setPopularArticle(popularArticle)
      console.log("popularArticle = ", popularArticle)
    }
    fetchData();
  }, [])

  return (
    <>
      {
        popularArticle !== 'empty' && popularArticle?.ArticleList &&
        <Root>
          <IconTitle
            iconImage={require('assets/images/icons/iconoir_book.png')}
            title="熱門點閱"
            moreUrl='https://ieknet.iek.org.tw/vip/default.aspx?actiontype=vip&indu_idno=17&domain=82'
          />
          <Content>
            {
              popularArticle?.ArticleList.map((article) => (
                <Article href={article.url} target="_blank">
                  <ArticleTitle>{article.title}</ArticleTitle>
                  <ArticleDate>
                    <img src={require('assets/images/icons/carbon_time.png')} alt="time" />
                    <h6>{article.date}</h6>
                  </ArticleDate>
                </Article>
              ))
            }
          </Content>
        </Root>
      }
    </>
  )
}

Hot.propTypes = {}

const Root = styled.section`
`;

// const Row = styled.div`
//   display: flex;
//   align-items: center;
//   border-bottom: 1px solid #DADADA;

//   ${vw('padding-bottom', 8, 15)}
//   ${vw('margin-bottom', 8, 15)}

//   > img {
//     width: auto;
//     height: auto;

//     ${vw('max-width', 12, 18)}
//     ${vw('max-height', 12, 18)}
//   }
// `;

// const Icon = styled.img`
//   height: fit-content;

//   ${vw('margin-right', 6, 10)}
// `;

// const Title = styled.h5`
//   font-family: 'Noto Sans TC';
//   font-style: normal;
//   font-weight: 500;

//   ${vw('font-size', 12, 18)}
//   ${vw('line-height', 20, 28)}
// `;

const Content = styled.div`
  display: grid;
  grid-template-columns: auto;

  @media ${media.tablet} {
    grid-template-columns: auto auto;
  }

  @media ${media.desktop} {
    grid-template-columns: auto auto auto;
  }

  ${vw('row-gap', 20)}
`;

const Article = styled.a`
  color: #252525;

  ${vw('padding-left', 3, 5, 10)}
  ${vw('padding-right', 3, 5, 10)}

  &:hover {
    color: #3398DC;
  }
`;

const ArticleTitle = styled.h4`
  font-family: 'Noto Sans TC';
  font-style: normal;
  font-weight: 500;
  /* identical to box height */
  letter-spacing: 0.05em;

  ${vw('font-size', 10, 14, 18)}
  ${vw('line-height', 18, 25, 26)}
  ${vw('margin-bottom', 10)}
`;

const ArticleDate = styled.div`
  display: flex;

  ${vw('margin-top', 10)}

  > img {
    ${vw('width', 12, 14, 15)}
    ${vw('height', 12, 14, 15)}
    
  }
  > h6 {
    font-family: 'Noto Sans TC';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 17px;

    ${vw('font-size', 9, 10, 12)}
    ${vw('line-height', 16, 18, 17)}
    ${vw('margin-left', 6)}
  }
`;

export default Hot
